import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from './LoadingScreen';

export const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirect';

const ProtectedRoute = ({ children, fallback = null }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return fallback ?? <LoadingScreen />;
  }

  if (!user) {
    const redirectTo = `${location.pathname}${location.search || ''}`;
    if (redirectTo && redirectTo !== '/login') {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, redirectTo);
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
